export class InventoryCheckboxFilterModel {
  brands: string[] = [];
  screenSizes: number[] = [];
  storageSizes: number[] = [];
  formFactors: string[] = [];
  features: string[] = [];
  osTypes: string[] = [];
}
